module.exports = {"TXTCLI_About_you":{"id":"TXTCLI_About_you","defaultMessage":"Σχετικά με εσένα"}}